module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[109]596.dcaca66.woff2";